import { CheckoutState } from '../../state';
import { getShowMandatoryCustomQuestionsAfterPayment } from '../../utils/statsig';
import { isPostCheckoutMandatoryQuestionsElegible } from '../postCheckoutMandatoryQuestions/isPostCheckoutMandatoryQuestionsElegible';
import {
    getIsPaymentView,
    isOrganizerQuestionsPage,
    isPreTicketsOrganizerQuestionsPage,
} from '../routing';
import { isOrganizationExcludedFromPostCheckoutMandatoryQuestions } from '../splitio';

export const shouldPrefillFirstAttendeeBasicInfoQuestions = (
    state: CheckoutState,
) => {
    const displayAttendeeBasicInfoQuestionsAfterPayment =
        !isOrganizationExcludedFromPostCheckoutMandatoryQuestions(state) &&
        (isPostCheckoutMandatoryQuestionsElegible(state) ||
            getShowMandatoryCustomQuestionsAfterPayment());

    const isPreOrderOrPreticketsPage =
        isOrganizerQuestionsPage(state) ||
        isPreTicketsOrganizerQuestionsPage(state);

    return (
        (getIsPaymentView(state) &&
            !displayAttendeeBasicInfoQuestionsAfterPayment) ||
        (isPreOrderOrPreticketsPage &&
            displayAttendeeBasicInfoQuestionsAfterPayment)
    );
};
